import React from "react";
import ReactSVG from 'react-svg';
import { analyticsService } from "src/services/AnalyticsService";

import "./Button.scss";

export class Button extends React.Component {
  onClick(e) {
    if (!this.props.analytics) return;
    const { category, action, label, value } = this.props.analytics;
    analyticsService.event({
      category,
      action,
      label,
      value,
    });
  }
  render() {
    const { children, icon, transparent, outline, target } = this.props;
    return (
      <a className={`Button ${transparent ? 'Button--transparent': ''} ${outline ? 'Button--outline': ''}`} href={this.props.href} onClick={e => this.onClick(e)} target={target}>
        { icon ? <span className="Button-icon"><ReactSVG src={icon} /></span> : null }
        <span className="Button-label">{children}</span>
      </a>
    );
  }
}
